function hasclass(element, name) {

	let classlist        = element.className;
	let classlistCleanup = classlist.replace(/[\n\t]/g, ' ');
	let isInClasslist    = classlistCleanup.includes(name);

	return isInClasslist;
}

export default hasclass;


// Polyfill for include in older browser (IE, android browser, ...)
if (!String.prototype.includes) {
	String.prototype.includes = function() {
		'use strict';
		return String.prototype.indexOf.apply(this, arguments) !== -1;
	};
}